<style>
  #BtnDiv {
    position: fixed;
    bottom: 25px;
    left: 25px;
    background: #282a39b0;
    padding: 10px;
    border-radius: 5px;
  }
</style>

<div [hidden]="Show_History_View>0" class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم نامه وارده</h5>

    <button type="button" *ngIf="Letter_Form_Id=='0' && Selected_DataList_LetterRequestCustomer_Record.id == 0"
      (click)="openModal_Customer(templateCustomer)" class="btn btn-warning" style="margin-left: 5px;"> جستجوی مشتری <i
        class="fa fa-vcard"></i> </button>
    <button type="button" *ngIf="Letter_Form_Id=='0'"
      (click)="openModal_LetterRequestCustomer(templateLetterRequestCustomer)" class="btn btn-danger"
      style="margin-left: 5px;"> پیوست به نامه <i class="fa fa-vcard"></i> </button>


    <br />
    <br />

    <div *ngIf="Data_Seleted_Customer.id>0">

      <form [formGroup]="AddNewLetter">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> شناسه درخواست </label>
            <input type="text" class="form-control" disabled value="{{Letter_Form_Code_Code}}" />
          </div>
          <div class="form-group col-md-4" style="display: none;">
            <label for="exampleInputEmail1"> شماره نامه </label>
            <input type="text" class="form-control" disabled value="{{Letter_Form_Code}}" />
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">کد مشتری بهفا </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.code}}" />
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">نام مشتری </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.name}}" />
          </div>
        </div>
        <br />
        <hr />
        <br />

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> موضوع نامه </label>
            <select class="custom-select" formControlName="subject_id">
              <option value="0">--- تایپ موضوع نامه ---</option>
              <option *ngFor="let item of DataList_SubjectLetter" [value]="item.id">{{item.title}}</option>
            </select>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> موضوع نامه </label>
            <input formControlName="draftTitle" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_draftTitle().valid && get_Form_draftTitle().touched"
              class="form-text text-muted MyErrorRedColor">موضوع نامه را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-4" *ngIf="Letter_Form_Id=='0'">
            <label for="exampleInputEmail1"> کد پیگیری </label>
            <input type="text" class="form-control" placeholder="اینجا تایپ کنید ..." formControlName="codePeygiri" />
          </div>

          <div class="form-group col-md-4" *ngIf="Letter_Form_Id!='0'">
            <label for="exampleInputEmail1"> کد پیگیری </label>
            <input type="text" class="form-control" value="{{codePeygiri}}" />
          </div>
        </div>

        <div class="row">

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> عنوان فرستنده </label>
            <select class="custom-select" formControlName="sex">
              <option value="0">سرکار خانم</option>
              <option value="1" selected>جناب آقای</option>
            </select>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> نام فرستنده </label>
            <input formControlName="giver_name" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_giver_name().valid && get_Form_giver_name().touched"
              class="form-text text-muted MyErrorRedColor">نام فرستنده را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> سمت فرستنده </label>
            <input formControlName="giver_semat" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_giver_semat().valid && get_Form_giver_semat().touched"
              class="form-text text-muted MyErrorRedColor">سمت فرستنده را وارد نمائید.</small>
          </div>
        </div>

        <div class="row">

          <div class="form-group col-md-4" style="display: none;">
            <label for="exampleInputEmail1"> پیوست </label>
            <select class="custom-select" formControlName="peyvast">
              <option selected value="0">ندارد</option>
              <option value="1">دارد</option>
            </select>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> شماره ی وارده </label>
            <input formControlName="bazgashtBeNamehShomareh" type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_bazgashtBeNamehShomareh().valid && get_Form_bazgashtBeNamehShomareh().touched"
              class="form-text text-muted MyErrorRedColor">شماره وارده را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> تاریخ وارده </label>
            <input formControlName="bazgashtBeNamehTarikh" type="text" class="form-control"
              #datepickerbazgashtBeNamehTarikh placeholder="اینجا تایپ کنید ...">
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
              [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerbazgashtBeNamehTarikh"></ng-persian-datepicker>
          </div>
        </div>

        <br />
        <hr />
        <br />

        <div *ngIf="canEditMainForm" class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">
              فایل/های ضمیمه
              <button (click)="Remove_uploadImage1()" type="button" *ngIf="UploadImageSrc" class="btn  btn-danger"><i
                  class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file"
              class="form-control" placeholder="اینجا تایپ کنید ...">
          </div>
        </div>

        <button *ngIf="canEditMainForm" type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc"
          class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن ضمیمه </button>

        <br />

        <div class="table-responsive" *ngIf="UploadImageSrc_List.length>0">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>فایل</th>
                <th>وضیعت</th>
                <th *ngIf="canEditMainForm">امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of UploadImageSrc_List">

                <td>{{UploadImageSrc_List.indexOf(item)+1}}</td>

                <td>

                  <a target="_blank" *ngIf="item.title.includes('.pdf')" href="{{BaseUrl}}File/Letter/{{item.title}}"
                    class="btn btn-success"><i class="fa fa-file-pdf-o"></i> PDF </a>

                  <a target="_blank" *ngIf="item.title.includes('.xls') || item.title.includes('.xlsx')"
                    href="{{BaseUrl}}File/Letter/{{item.title}}" class="btn btn-success"><i
                      class="fa fa-file-pdf-o"></i> PDF </a>

                  <img
                    *ngIf="!item.title.includes('.pdf') && !item.title.includes('.xls') && !item.title.includes('.xlsx')"
                    (click)="openModal(templateImage,item.title)" style="width: 150px;cursor: zoom-in;"
                    src="{{BaseUrl}}File/Letter/{{item.title}}" />
                </td>
                <td>
                  <p (click)="SetLetterRequestCustomerImageShow(item)" *ngIf="item.del" style="color: #489b39;">نمایش
                    برای کارشناس</p>
                  <p (click)="SetLetterRequestCustomerImageShow(item)" *ngIf="!item.del" style="color: crimson;">عدم
                    نمایش برای کارشناس</p>
                </td>
                <td *ngIf="canEditMainForm">
                  <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                    <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;"
                          (click)="UploadImageSrc_List_Delete(UploadImageSrc_List.indexOf(item))"
                          class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                      </div>
                    </div>
                  </div>
                </td>

              </tr>
            </tbody>
          </table>
        </div>
      </form>

      <br />
      <br />

    </div>


    <br />
    <br />

    <div id="BtnDiv">

      <img *ngIf="Data_Seleted_Customer.id>0 && InProccessing" src="assets/Loading.gif" style="width: 25px;" />

      <ng-container *ngFor="let item of Data_List_Order">

        <button *ngIf="item.submit && !InProccessing" type="button" (click)="OpenOrderDialog(templateOrder,item)"
          [disabled]="!AddNewLetter.valid" [class]="item.cls" style="margin-left: 5px;"> <i [class]="item.icon"></i>
          {{item.title}} </button>
        <button *ngIf="item.hasRefer && !item.submit && !InProccessing" type="button"
          (click)="OpenOrderDialog(templateOrder,item)" [class]="item.cls" style="margin-left: 5px;"><i
            [class]="item.icon"></i> {{item.title}} </button>
        <button *ngIf="!item.hasRefer && !item.submit && !item.copy && !InProccessing" type="button"
          (click)="OpenOrderDialog(templateOrder,item)" [class]="item.cls" style="margin-left: 5px;"> <i
            [class]="item.icon"></i> {{item.title}} </button>
        <button *ngIf="!item.hasRefer && !item.submit && item.copy && !InProccessing" type="button"
          [routerLink]="['/LetterRequestCustomerForm',{draft:Selected_DataList_LetterRequestCustomer_Record.id}]"
          [class]="item.cls" style="margin-left: 5px;"> <i [class]="item.icon"></i> {{item.title}} </button>

      </ng-container>


      <button *ngIf="Letter_Form_Id>0 && !InProccessing" (click)="ReadHistory_Letter()" type="button"
        class="btn btn-warning" style="margin-left: 5px;"> <i class="fa fa-file-text"></i> جزئیات نامه </button>

      <button *ngIf="Letter_Form_Id>0 && !InProccessing" (click)="OpenNoteDialog(templateComment)" type="button"
        class="btn btn-success" style="margin-left: 5px;"> <i class=" fa fa-sticky-note-o"></i> ثبت نظر </button>


    </div>

    <br />
    <br />


  </div>
</div>

<div *ngIf="Show_History_View==1" class="card card-statistics mb-30">

  <div class="card-body">
    <div class="tab nav-border" style="position: relative;">
      <div class="d-block d-md-flex justify-content-between">
        <div class="d-block w-100">
          <h5 class="card-title border-0 pb-0">جزئیات نامه '{{Letter_Form_Code}}'</h5>
        </div>
        <div class="d-block d-md-flex nav-tabs-custom">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active show" id="months-tab" data-toggle="tab" href="#order" role="tab"
                aria-controls="months" aria-selected="true">تاریخچه ارجاع</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#mission" role="tab"
                aria-controls="months" aria-selected="true">پیوست نامه</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#flowchart" role="tab"
                aria-controls="months" aria-selected="true">فلوچارت ارجاع</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <app-LetterRequestCustomerHistory [DataList_History]="DataList_History"></app-LetterRequestCustomerHistory>
          </div>
          <button *ngIf="!InProccessing && canDeleteHistoryRecord && DataList_Peyvast.length==1" type="button"
            (click)="DeleteLetterHistoryRecord()" class="btn btn-danger"><i class="fa fa-remove"></i>حدف آخرین
            ارجاع</button>
        </div>
        <div class="tab-pane fade show" id="mission" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <app-LetterRequestCustomerPeyvast [canOpenPeyvast]="canOpenPeyvast"
              [DataList_Peyvast]="DataList_Peyvast"></app-LetterRequestCustomerPeyvast>

          </div>
        </div>
        <div class="tab-pane fade show" id="flowchart" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div>
              <app-LetterRequestCustomerTreeHistory [DataList_History]="DataList_History">
              </app-LetterRequestCustomerTreeHistory>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="card-body">
    <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-left: 5px;"> بازگشت
    </button>

  </div>



</div>



<ng-template #templateCustomer>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات مشتری </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Customer.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">نام مشتری </label>
          <input type="text" class="form-control" (keyup)="ReadData_Customer_KeySearch()"
            [(ngModel)]="Search_CodeName_Customer_Table" placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>کد مشتری بهفا</th>
              <th>نام مشتری</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Customer
            | paginate
                    : {
                        id: 'DataList_Customer',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Customer).length
                      }">
              <td>{{DataList_Customer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.name}}</td>
              <td (click)="Set_Selected_Customer_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingCustomer" type="button" (click)="ReadData_Customer()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Customer.hide()">بستن</button>
  </div>
</ng-template>


<ng-template #templateCode>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> شماره نامه </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Code.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p>شماره نامه صادره برای (نام مشتری) <b>'{{Letter_Form_Code}}'</b></p>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-danger" (click)="modalRef_Code.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateLetterRequestCustomer>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات نامه </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_LetterRequestCustomer.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> شماره نامه </label>
          <input type="text" class="form-control" [(ngModel)]="Search_code_LetterRequestCustomer"
            placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> موضوع نامه </label>
          <input type="text" class="form-control" [(ngModel)]="Search_persianDate_LetterRequestCustomer"
            placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">نام مشتری </label>
          <input type="text" class="form-control" [(ngModel)]="Search_customer_LetterRequestCustomer"
            placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شماره نامه</th>
              <th>نوع نامه</th>
              <th>نام مشتری</th>
              <th>موضوع نامه </th>
              <th>نام گیرنده</th>
              <th>سمت گیرنده</th>
              <th>کاربر فرستنده</th>
              <th>کاربر گیرنده</th>
              <th>وضیعت</th>
              <th>پیام</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_LetterRequestCustomer
            |filter:Search_persianDate_LetterRequestCustomer:'subject_name'
            |filter:Search_customer_LetterRequestCustomer:'customer'
            |filter:Search_code_LetterRequestCustomer:'code'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_LetterRequestCustomer
                        |filter:Search_persianDate_LetterRequestCustomer:'subject_name'
                        |filter:Search_code_LetterRequestCustomer:'code'
                        |filter:Search_customer_LetterRequestCustomer:'customer').length
                      }
            ">
              <td>{{DataList_LetterRequestCustomer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.letterType}}</td>
              <td>{{item.customer}}</td>
              <td>{{item.subject_name}}</td>
              <td>{{item.giver_name}}</td>
              <td>{{item.giver_semat}}</td>
              <td>{{item.lastSender}}</td>
              <td>{{item.lastGiver}}</td>
              <td>{{item.lastSection}}</td>
              <td>{{item.lastOrder}}</td>
              <td (click)="Set_Selected_LetterRequestCustomer(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_LetterRequestCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_LetterRequestCustomer" type="button" (click)="ReadData_LetterRequestCustomer()"
      class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_LetterRequestCustomer.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateOrder>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> {{Selected_Order_Operation.title}} </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Order.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12" *ngIf="Selected_Order_Operation.hasRefer || Selected_Order_Operation.submit">
        <label for="exampleInputEmail1">گیرنده</label>
        <select class="custom-select" [(ngModel)]="SelectedLetterRole">
          <option value="0">انتخاب کنید</option>
          <option *ngFor="let item of Data_list_LetterRole" [value]="item.id">{{item.title}}</option>
        </select>
      </div>
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">توضیحات</label>
        <input type="text" class="form-control" [(ngModel)]="LetterHistoryDsc" placeholder="اینجا تایپ کنید ...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success"
      (click)="SubmitAddNewLetter_Co(templateCode,Selected_Order_Operation)"> ارسال و ثبت </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Order.hide()">بستن</button>
  </div>
</ng-template>


<ng-template #templateImage>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> نمایش عکس </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img style="max-width: 350px;" src="{{BaseUrl}}File/Letter/{{ModalimageUrl}}" />
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Letter/{{ModalimageUrl}}"><i
        class="fa fa-download"></i> دانلود </a>
    <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateComment>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> ثبت نظر جدید برای مشتری '{{Data_Seleted_Customer.name}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Note.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">شرح</label>
        <textarea type="text" class="form-control" [(ngModel)]="Note_Dsc" placeholder="اینجا تایپ کنید ...">
        </textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" *ngIf="!InProccessing" class="btn btn-success" (click)="SubmitNote()">
      ارسال و ثبت </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Note.hide()">بستن</button>
  </div>
</ng-template>